import { useState, useEffect } from 'react';
import { validateField } from '../services/inputCheck';
import { ebookService } from '../services/ebookService';

const useEbookForm = ({ setNotification, downloadLink, user }) => {
    const [values, setValues] = useState({
        email: '',
        prenom: '',
        codePostal: ''
    });

    useEffect(() => {
        if (user) {
            setValues(prev => ({
                email: user.email || prev.email,
                prenom: user.firstname || prev.prenom,
                codePostal: user.codePostal || prev.codePostal
            }));
        }
    }, [user]);
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [submitMessage, setSubmitMessage] = useState('');
    const [userEmail, setUserEmail] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setValues(prev => ({
            ...prev,
            [name]: value
        }));

        // Valider le champ en temps réel
        let fieldError = '';
        
        // Adapter les noms de champs pour validateField
        switch (name) {
            case 'prenom':
                fieldError = validateField('firstname', value);
                break;
            case 'codePostal':
                fieldError = validateField('zipcode', value);
                break;
            default:
                fieldError = validateField(name, value);
        }
        
        setErrors(prev => ({
            ...prev,
            [name]: fieldError
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        
        // Valider email
        const emailError = validateField('email', values.email);
        if (emailError) newErrors.email = emailError;
        
        // Valider prénom
        const prenomError = validateField('firstname', values.prenom);
        if (prenomError) newErrors.prenom = prenomError;
        
        // Valider code postal
        const codePostalError = validateField('zipcode', values.codePostal);
        if (codePostalError) newErrors.codePostal = codePostalError;

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!validateForm()) {
            setSubmitMessage('Veuillez corriger les erreurs du formulaire');
            return;
        }

        setIsSubmitting(true);
        setSubmitSuccess(false);
        setSubmitMessage('');
        
        try {
            // Exécution de reCAPTCHA v3
            const token = await window.grecaptcha.execute(
                process.env.REACT_APP_RECAPTCHA_SITE_KEY, 
                { action: 'ebook_form' }
            );
            
            // Appel à l'API avec le token reCAPTCHA
            const response = await ebookService.registerForEbook({
                ...values,
                recaptchaToken: token
            }, downloadLink);
            
            if (response.success) {
                setUserEmail(values.email);
                setSubmitSuccess(true);
                setSubmitMessage(response.message || 'Inscription réussie ! Vérifiez votre email.');
                
                if (setNotification) {
                    setNotification({
                        message: "Ton e-book t'attend dans ta boîte mail !",
                        type: 'success'
                    });
                }
                
                // Reset du formulaire
                setValues({
                    email: '',
                    prenom: '',
                    codePostal: ''
                });
                setErrors({});
            } else {
                throw new Error(response.message || 'Erreur lors de l\'inscription');
            }
            
        } catch (error) {
            console.error('Erreur useEbookForm:', error);
            setSubmitSuccess(false);
            setSubmitMessage(error.message || 'Une erreur est survenue. Veuillez réessayer.');
            
            if (setNotification) {
                setNotification({
                    message: "Une erreur est survenue lors de l'inscription",
                    type: 'error'
                });
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    return {
        values,
        errors,
        isSubmitting,
        submitSuccess,
        submitMessage,
        userEmail,
        handleChange,
        handleSubmit
    };
};

export default useEbookForm;